import { SalesPromoForm } from "./SalesPromoForm/SalesPromoForm.page";


function SalesPromoAddPage() {

  return (
    <SalesPromoForm title="Add" />
  );
}

export default SalesPromoAddPage;
